<template>
  <div class="whitespace-nowrap text-base-90">
    <div
      class="flex items-center justify-start px-2 space-x-2 context-menu-item foo"
      :class="{
        'hover:bg-base-10 cursor-pointer': clickable && !disabled,
        'text-xs leading-6': size === 'sm',
        'leading-9': size === 'md',
        'disabled': disabled,
        'border-b border-base-30': hasDivider,
      }"
      @click="handleItemClick"
    >
      <slot />
    </div>
    <slot name="detail" />
  </div>
</template>

<script>
export default {
  props: {
    clickable: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'md',
    },
    hasDivider: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleItemClick(event) {
      if (!this.clickable) {
        event.stopPropagation()
      }
      if (!this.disabled) {
        this.$emit('click', event)
      }
    },
  },
}
</script>

<style lang="scss">
.context-menu-item {
  @apply px-2 space-x-2 leading-9 whitespace-nowrap hover:bg-base-10;
  @apply flex items-center justify-start cursor-pointer;
}
.disabled {
  @apply opacity-50 cursor-not-allowed;
}
.text-danger {
  color: #D1303A !important;
}
</style>
